import React, { useState } from 'react';
import { Col, Row, Button, Spinner } from 'reactstrap';
import PhoneInput from '../../../components/input/contact-input/PhoneInput';
import { isValidPhoneNumber } from 'react-phone-number-input';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import { showToast } from '../../../utils/toast/toast';

const PhoneSearchStep = ({ onUserFound, onUserNotFound }) => {
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const axios = useAxiosPrivate();

  const handlePhoneSearch = async () => {
    if (!phone?.trim()) {
      setPhoneError('Phone number is required');
      return;
    }

    if (!isValidPhoneNumber(phone)) {
      setPhoneError('Invalid phone number');
      return;
    }

    setLoading(true);
    setPhoneError('');

    try {
      const phoneQuery = encodeURIComponent(phone.trim());
      const res = await axios.get(`/users/check-exists?phone=${phoneQuery}`);

      if (res.data.exists) {
        onUserFound(res.data.user, phone);
      } else {
        onUserNotFound(phone);
      }
    } catch (err) {
      showToast(err.response?.data?.message || 'Error checking phone number', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="text-center py-4">
      <h4 className="mb-4">Enter Phone Number</h4>
      <Row className="justify-content-center">
        <Col md="6">
          <div className="form-group">
            <PhoneInput
              className="phoneInput w-100"
              defaultCountry="AE"
              name="phone"
              placeholder="Enter phone number"
              value={phone}
              onChange={(value) => {
                setPhone(value);
                setPhoneError('');
              }}
              onError={(error) => setPhoneError(error)}
            />
            {phoneError && <span className="invalid">{phoneError}</span>}
          </div>
          <Button 
            color="primary" 
            size="lg" 
            onClick={handlePhoneSearch}
            disabled={loading || !phone}
            className="mt-3"
          >
            {loading ? (
              <Spinner style={{ width: '1rem', height: '1rem' }} />
            ) : (
              'Search Lead'
            )}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default PhoneSearchStep;